export enum CoverageStatus {
  NOT_COVERED = 'NOT_COVERED',
  COVERED = 'COVERED',
  SECURITY_MARGIN = 'SECURITY_MARGIN',
  NONE = 'NONE'
}
